import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import api from "services/api";
// import ls from "services/ls";
import { __ } from "services/Translator";

export default function Faqs(props) {
  const [faqs, setFaqs] = useState([]);
  const [selectedFaqCategory, setSelectedFaqCategory] = useState({
    category: "",
    faqs: [],
  });

  const getFaqs = async () => {
    props.setSpinner(true);
    try {
      var response = await api.get("/get-faqs");
      if (response.status === 200) {
        const faqData = Array.isArray(response.data) ? response.data : [];
        if (selectedFaqCategory.faqs.length === 0) {
          setSelectedFaqCategory(
            faqData[0] || {
              category: "",
              faqs: [],
            }
          );
        }
        setFaqs(faqData);
      }
    } finally {
      props.setSpinner(false);
    }
  };

  useEffect(() => {
    getFaqs();
  }, []);

  return (
    <section className="faqs_area">
      <div className="container">
        <div className="section_title">{__("Join our Elite Joker Family")}</div>

        <div className="paragraph text-center padding_top_15">
          {__("Lorem ipsum dolor sit amet, consectetur adipiscing elit,")}
        </div>
        <div className="paragraph text-center margin_bottom_30">
          {__("sed do eiusmod tempor, Lorem ipsum dolor .")}
        </div>

        <div className="section_headline faq_area_heading margin_bottom_30">
          <div className="headline_text">
            {__("Frequently Asqued Questions")}
          </div>
          <div className="headline_action">
            {faqs.map((faqCategory, index) => (
              <React.Fragment key={index}>
                <button
                  className={
                    selectedFaqCategory.category === faqCategory.category
                      ? "items active " + props.landingType
                      : "items"
                  }
                  onClick={() => setSelectedFaqCategory(faqCategory)}
                >
                  {faqCategory.category}
                </button>

                <img
                  className="bullet_icon_faq"
                  src={
                    require("../assets/images/new-landing/icons/card-1.png")
                  }
                  alt="Card-Icon"
                />
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="faqs">
          <Accordion>
            {(selectedFaqCategory?.faqs || []).map((faq, index2) => (
              <Accordion.Item
                key={index2}
                eventKey={index2}
                className="chimp-accordion"
              >
                <Accordion.Header
                  className={"faq__question " + props.landingType}
                >
                  {faq.title} <i></i>
                </Accordion.Header>
                <Accordion.Body className="faq__answer">
                  {faq.description}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
